import { useFrontendTool } from "@copilotkit/react-core"
import cropsApi from "api/crops"
import cropsRecipesApi from "api/crops_recipes"
import cyclesApi from "api/cycles"
import recipesApi from "api/recipes"
import { LastDateRange } from "stores/planner/utils/fetch"
import { stringToDateRange } from "utils"
import { getFarmId } from "./utils"
import { cropToCopilot, cycleToCopilot, recipeToCopilot } from "./utils/toCopilot"
import { TOOLS } from "./utils/types"


/**
 */
export function useGetValues() {

	useFrontendTool({
		name: TOOLS.GET_CROPS_LIST,
		description: `Restituisce la lista di tutti i CROPS disponibili.
{id, uuid, name, variety, expectedYieldPerMq, cost1kg, seedCostPerMillion}[]
`,
		parameters: [],
		handler: async () => {
			const crops = (await cropsRecipesApi.index())?.data
			if ( !crops || crops.length === 0) return {
				success: false,
				error: "Nessun CROP disponibile"
			}
			return crops.map(crop => cropToCopilot(crop))
		},
	})

	useFrontendTool({
		name: TOOLS.GET_CROP_DETAIL,
		description: `Restituisce il dettaglio di un CROP.
`,
		parameters: [
			{
				name: "crop_id",
				description: "L'id numerico del CROP di cui si vuole il dettaglio.",
				type: "number",
				required: true,
			},
		],
		handler: async ({ crop_id }) => {
			const crop = (await cropsRecipesApi.get(crop_id)).data
			if (!crop) return {
				success: false,
				error: `Nessun CROP trovato con id "${crop_id}"`
			}
			return crop
		},
	})

	useFrontendTool({
		name: TOOLS.GET_RECIPES_LIST,
		description: `Restituisce la lista di tutti i RECIPE disponibili.
{id, uuid, name, farmIds, totaldays}[]
`,
		parameters: [],
		handler: async () => {
			const recipes = (await recipesApi.index())?.data
			if ( !recipes || recipes.length === 0) return {
				success: false,
				error: "Nessun RECIPE disponibile"
			}
			return recipes.map(recipe => recipeToCopilot(recipe))
		},
	})

	useFrontendTool({
		name: TOOLS.GET_RECIPE_DETAIL,
		description: `Restituisce il dettaglio di un RECIPE.
`,
		parameters: [
			{
				name: "recipe_id",
				description: "L'id numerico del RECIPE di cui si vuole il dettaglio.",
				type: "number",
				required: true,
			},
		],
		handler: async ({ recipe_id }) => {
			const recipe = (await recipesApi.get(recipe_id)).data
			if (!recipe) return {
				success: false,
				error: `Nessun RECIPE trovato con id "${recipe_id}"`
			}
			return recipe
		},
	})



	useFrontendTool({
		name: TOOLS.GET_CYCLES_LIST,
		description: `Restituisce la lista dei CYCLES in una FARM in un determinato range di tempo.`,
		parameters: [
			{
				name: "farm_id",
				type: "string",
				description: `'id' numerico, il 'code', parte del 'name' di una FARM a cui appartengono i CYCLES`,
				required: true,
			},
			{
				name: "date_start",
				description: `(yyyy-mm-dd) solo i CICLI che si sono verificati dopo questa data. Se non presente prende le disponibili.`,
				type: "string",
				required: false,
			},
			{
				name: "date_end",
				description: `(yyyy-mm-dd) solo i CICLI che si sono verificati prima questa data. Se non presente prende le disponibili.`,
				type: "string",
				required: false,
			},

		],
		handler: async ({ farm_id, date_start, date_end}) => {
			if (!farm_id) return {
				success: false,
				error: "Il parametro 'farm_id' è obbligatorio"
			}
			let farmId: number = getFarmId(farm_id)
			if (!farmId) return {
				success: false,
				error: `Nessuna farm trovata con 'id' o 'code' o nome che corrisponda a "${farm_id}"`
			}

			const range = stringToDateRange(date_start, date_end) ?? LastDateRange
			const cycles = (await cyclesApi.indexByFarm(farmId, range))?.data

			return cycles.map(cycle => cycleToCopilot(cycle))
		},
	})

	useFrontendTool({
		name: TOOLS.GET_CYCLE_DETAIL,
		description: `Restituisce il dettaglio di un CYCLE.
`,
		parameters: [
			{
				name: "farm_id",
				type: "string",
				description: `'id' numerico, il 'code', parte del 'name' di una FARM a cui appartengono i CYCLES`,
				required: true,
			},
			{
				name: "cycle_id",
				description: "L'id numerico del CYCLE di cui si vuole il dettaglio.",
				type: "number",
				required: true,
			},
		],
		handler: async ({ farm_id, cycle_id }) => {
			if (!farm_id) return {
				success: false,
				error: "Il parametro 'farm_id' è obbligatorio"
			}
			let farmId: number = getFarmId(farm_id)
			if (!farmId) return {
				success: false,
				error: `Nessuna farm trovata con 'id' o 'code' o nome che corrisponda a "${farm_id}"`
			}

			const cycle = (await cyclesApi.get(farmId, cycle_id)).data
			return cycle
		},
	})
}


